import type { PayloadAction, WithSlice } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { rootReducer } from '~shared/store';

type State = {
  sessionId?: string;
};

const initialState: State = {
  sessionId: undefined,
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSession: (state, action: PayloadAction<State['sessionId']>) => ({
      ...state,
      sessionId: action.payload,
    }),
    resetSession: () => initialState,
  },
});

export const sessionActions = sessionSlice.actions;

declare module '~shared/store' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
  export interface LazyLoadedSlices extends WithSlice<typeof sessionSlice> {}
}

const injectedSessionSlice = sessionSlice.injectInto(rootReducer);

export const sessionSelectors = injectedSessionSlice.selectors;
